import { useCallback } from 'react';
import { useLocalization } from '@/services/localizationService';
import LinkWithQuery from '@/ui/content/LinkWithQuery';
import { useIsRedirectedFromReminiAi } from '@/features/reminiaiFunnel/useIsRedirectedFromReminiAi';

/* `forceLegalLinks` emphasises the links on the homepage (both arms);
 * elsewhere they stay gated on the remini.ai redirect. */
export const useLegalCopy = ({
  forceLegalLinks = false,
}: { forceLegalLinks?: boolean } = {}) => {
  const { t, data } = useLocalization();
  const isRedirectedFromReminiAi = useIsRedirectedFromReminiAi();

  const onTermsOfServiceClick = useCallback((e) => e.stopPropagation(), []);
  const onPrivacyPolicyClick = useCallback((e) => e.stopPropagation(), []);

  const linkClassName =
    isRedirectedFromReminiAi || forceLegalLinks
      ? 'underline font-bold text-[#FFFFFF7A]'
      : 'underline';

  return {
    acceptTermsText: t(data.common.byContinuingAcceptTosAndPrivacy, {
      tos: (text) => (
        <a
          className={linkClassName}
          href="https://bendingspoons.com/tos.html?app=1470373330"
          target="_blank"
          rel="noreferrer nofollow"
          onClick={onTermsOfServiceClick}
        >
          {text}
        </a>
      ),
      privacy: (text) => (
        <LinkWithQuery path="/privacy-and-cookie-policy">
          <a
            className={linkClassName}
            target="_blank"
            onClick={onPrivacyPolicyClick}
          >
            {text}
          </a>
        </LinkWithQuery>
      ),
    }),
  };
};
